var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.info
        ? _c(
            "el-dialog",
            {
              staticClass: "editDialog",
              attrs: {
                title: "编辑认证信息",
                visible: _vm.dialogVisible,
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                width: "60%",
                center: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
                close: _vm.onHandleClose,
              },
            },
            [
              _c(
                "div",
                { staticClass: "editDialog-cnt" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "refCityForm",
                      staticClass: "demo-addForm",
                      attrs: {
                        "label-width": "200px",
                        model: _vm.addForm,
                        rules: _vm.cityRules,
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "主体性质",
                            prop: "certification_type",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.addForm.certification_type,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.addForm,
                                    "certification_type",
                                    $$v
                                  )
                                },
                                expression: "addForm.certification_type",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 10 } }, [
                                _vm._v("个人"),
                              ]),
                              _c("el-radio", { attrs: { label: 20 } }, [
                                _vm._v("个体工商户"),
                              ]),
                              _c("el-radio", { attrs: { label: 30 } }, [
                                _vm._v("企业"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "营业执照", prop: "license_img" } },
                        [
                          _c(
                            "el-upload",
                            {
                              class: {
                                hide:
                                  _vm.license_img.length || !_vm.license_img,
                              },
                              attrs: {
                                action: _vm.httpurl,
                                "on-preview": _vm.onHandlePictureCardPreview,
                                "file-list": _vm.license_img,
                                headers: { token: _vm.token },
                                "list-type": "picture-card",
                                "on-success": _vm.onsuccess,
                                "before-remove": () =>
                                  _vm.onHandleDeleteFile("license_img"),
                                limit: 1,
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-plus",
                                attrs: { slot: "trigger" },
                                slot: "trigger",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "统一社会信息码", prop: "uscc" } },
                        [
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.addForm.uscc,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.addForm, "uscc", $$v)
                                  },
                                  expression: "addForm.uscc",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "持卡人身份证国徽页图片",
                            prop: "idcard_a",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.uploadLoading,
                                  expression: "uploadLoading",
                                },
                              ],
                              class: {
                                hide: _vm.idcard_a.length || !_vm.idcard_a,
                              },
                              attrs: {
                                action: "#",
                                "on-preview": _vm.onHandlePictureCardPreview,
                                "file-list": _vm.idcard_a,
                                "list-type": "picture-card",
                                "http-request": (data) =>
                                  _vm.onHandleUploadFile(data, "idcard_a"),
                                "before-remove": () =>
                                  _vm.onHandleDeleteFile("idcard_a"),
                                limit: 1,
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-plus",
                                attrs: { slot: "trigger" },
                                slot: "trigger",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "持卡人身份证人像页图片",
                            prop: "idcard_b",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.uploadLoading,
                                  expression: "uploadLoading",
                                },
                              ],
                              class: {
                                hide: _vm.idcard_b.length || !_vm.idcard_b,
                              },
                              attrs: {
                                action: "#",
                                "on-preview": _vm.onHandlePictureCardPreview,
                                "file-list": _vm.idcard_b,
                                "list-type": "picture-card",
                                "http-request": (data) =>
                                  _vm.onHandleUploadFile(data, "idcard_b"),
                                "before-remove": () =>
                                  _vm.onHandleDeleteFile("idcard_b"),
                                limit: 1,
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-plus",
                                attrs: { slot: "trigger" },
                                slot: "trigger",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm.addForm.certification_type == 30
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "企业联系电话",
                                prop: "company_mobile",
                              },
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入" },
                                    model: {
                                      value: _vm.addForm.company_mobile,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.addForm,
                                          "company_mobile",
                                          $$v
                                        )
                                      },
                                      expression: "addForm.company_mobile",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.addForm.certification_type != 10
                                ? "法人姓名"
                                : "持卡人姓名",
                            prop: "idcard_name",
                          },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.addForm.idcard_name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.addForm, "idcard_name", $$v)
                                  },
                                  expression: "addForm.idcard_name",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.addForm.certification_type != 10
                                ? "法人身份证号"
                                : "持卡人身份证号",
                            prop: "idcard_code",
                          },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.addForm.idcard_code,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.addForm, "idcard_code", $$v)
                                  },
                                  expression: "addForm.idcard_code",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.addForm.certification_type != 10
                                ? "法人手机号码"
                                : "联系人电话",
                            prop: "manage_mobile",
                          },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.addForm.manage_mobile,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.addForm, "manage_mobile", $$v)
                                  },
                                  expression: "addForm.manage_mobile",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm.addForm.certification_type == 20
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "绑卡类型",
                                prop: "account_type",
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.addForm.account_type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.addForm, "account_type", $$v)
                                    },
                                    expression: "addForm.account_type",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 10 } }, [
                                    _vm._v("个人"),
                                  ]),
                                  _c("el-radio", { attrs: { label: 30 } }, [
                                    _vm._v("企业"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c("el-button", { on: { click: _vm.onHandleClose } }, [
                    _vm._v("关闭"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.submitLoading },
                      on: { click: _vm.qr },
                    },
                    [_vm._v("确认")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }